// v3.4.509 — تتبّع نشاط المستخدم لسياسة الجلسات (خروج بعد 30 دقيقة بلا نشاط)
// آخر تفاعل (فأرة/لوحة مفاتيح/لمس/تمرير) يُحفظ في الذاكرة وفي localStorage ليشمل كل تبويبات النظام.
// كل طلب للخادم يحمل X-Idle-Ms = المدة منذ آخر تفاعل، فطلبات الخلفية الدورية لا تُبقي الجلسة حيّة.
const KEY = "rael:lastActivity";
export const IDLE_LIMIT_MS = 30 * 60 * 1000;
export const IDLE_WARN_MS = 28 * 60 * 1000;
let last = Date.now();
let wrote = 0;
let onActive = null; // يُستدعى عند التفاعل (لنبضة إبقاء الجلسة)

function mark() {
  const now = Date.now();
  last = now;
  if (now - wrote > 5000) { wrote = now; try { localStorage.setItem(KEY, String(now)); } catch (_) { /* التخزين قد يكون محجوبًا */ } }
  if (onActive) onActive(now);
}
export function lastActivity() {
  let shared = 0;
  try { shared = Number(localStorage.getItem(KEY)) || 0; } catch (_) { /* */ }
  return Math.max(last, shared);
}
export const idleMs = () => Math.max(0, Date.now() - lastActivity());
export function setOnActive(fn) { onActive = fn; }
export function resetActivity() { mark(); }

if (typeof window !== "undefined") {
  ["mousedown", "keydown", "touchstart", "wheel"].forEach(ev => window.addEventListener(ev, mark, { passive: true, capture: true }));
  let mv = 0;
  window.addEventListener("mousemove", () => { const n = Date.now(); if (n - mv > 3000) { mv = n; mark(); } }, { passive: true });
  try { localStorage.setItem(KEY, String(last)); } catch (_) { /* */ }
}
